import { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"
import { toast } from "react-toastify"
import { intakeQueryKeys } from "@/api/query-keys/intakes"
import { fetchIntakeById } from "@/api/services/intake"
import { Intake } from "@/api/types/intake"
import { canEditIntakeResults } from "./shouldRenderPresenceButtons"

export async function checkIntakeResultsEditable({
  queryClient,
  intakeId,
}: {
  queryClient: QueryClient
  intakeId: Intake["id"]
}) {
  const { data: intake } = await queryClient.ensureQueryData({
    queryKey: intakeQueryKeys.detail(intakeId),
    queryFn: () => fetchIntakeById({ intakeId }),
  })

  if (canEditIntakeResults(intake)) return

  toast.error(
    "De resultaten van deze intake kunnen niet meer worden aangepast.",
  )

  throw redirect({
    to: "/beheer/intakes/$intakeId",
    params: { intakeId: intakeId.toString() },
  })
}
